export const numberErrorMessage = {
  invalid_type_error: 'Only natural numbers are allowed',
}
